<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('students')"
      :columns="columns"
      :column_search="true"
      resource_url="/student/datatables"
      :page_length="100"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="inscribe">
          <span class="icon"><i class="fa fa-edit"></i></span>
          <span>{{ $t("inscribe") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <student-modal ref="student_modal" @success="refresh" />
  <inscription-modal ref="inscription_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import StudentModal from "./student_modal/Index.vue";
import InscriptionModal from "./inscription_modal/Index.vue";

export default {
  name: "StudentsDatatable",
  components: { GenericTable, StudentModal, InscriptionModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("student"),
          name: "id_card_number",
          searchable: false,
          data: (row) => {
            // return row.id_card_number || "";
            return `<div class="title is-6">
                      <span class="icon">
                        <i class="fa fa-user"></i>
                      </span><a href="/student/profile/${row.uuid}">${row.first_name} ${row.surname}</a></div>
                    <div class="subtitle is-6">
                      <span class="icon">
                        <i class="fa fa-id-card"></i>
                      </span><span>${row.id_card_number}</span>
                    </div>`;
          },
        },
        // {
        //   title: v.$t("name"),
        //   searchable: false,
        //   // width: "30%",
        //   data: (row) => {
        //     return `<a href="/student/profile/${row.uuid}">${row.first_name} ${row.surname}</a>`;
        //     // return `${row.first_name} ${row.surname}`;
        //   },
        // },
        {
          title: v.$t("phone"),
          name: "phone",
          searchable: true,
          // width: "30%",
          data: (row) => {
            // return `<a href="/student/profile/${row.uuid}">${row.first_name} ${row.surname}</a>`;
            return row.phone || "";
          },
        },
        {
          title: v.$t("email"),
          name: "email",
          searchable: true,
          // width: "30%",
          data: (row) => {
            // return `<a href="/student/profile/${row.uuid}">${row.first_name} ${row.surname}</a>`;
            return row.email || "";
          },
        },
        {
          title: v.$t("inscriptions"),
          searchable: false,
          // width: "30%",
          data: (row) => {
            let r = "";
            if (
              row.student_inscriptions &&
              row.student_inscriptions.length > 0
            ) {
              r = row.student_inscriptions
                .map((i) => {
                  return `<div class="tags has-addons mb-1">
                            <span class="tag is-dark"
                              >${i.program.name}</span
                            >
                            <span class="tag ">${i.period.name}</span>
                            <a class="tag is-delete is-danger" @click="remove(item)"></a>
                          </div>`;
                  // return `<span class="tag is-info">${i.program.name}</span>`;
                })
                .join(" ");
            }
            return r;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.student_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete student?"),
                    v,
                    () => {
                      del("/student", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.student_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    inscribe() {
      let v = this;
      v.$refs.inscription_modal.show_modal();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
